module.exports = __webpack_public_path__ + "img/21.f5b69d84.png";